import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/terms")({
  component: TermsOfService,
});

function TermsOfService() {
  return (
    <div className="bg-topography min-h-svh">
      <div className="container mx-auto max-w-4xl px-6 py-12 md:py-16">
        <div className="mb-6">
          <Link
            to="/"
            className="text-muted-foreground hover:text-primary text-sm underline underline-offset-4"
          >
            ← Back to Home
          </Link>
        </div>

        <Card>
          <CardContent className="p-8 md:p-12">
            <div className="flex items-center gap-4 mb-8">
              <img src="/cte-logo.png" alt="CTE Logo" className="h-10 w-auto" />
              <h1 className="text-3xl font-bold">Terms of Service</h1>
            </div>

            <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
              <p className="text-muted-foreground">
                Last updated: December 2, 2025
              </p>

              <section className="space-y-4">
                <h2 className="text-xl font-semibold">
                  1. Acceptance of Terms
                </h2>
                <p>
                  By accessing or using the iPlant platform and related services
                  provided by CTE ("Company", "we", "us", or "our"), you agree
                  to be bound by these Terms of Service. If you do not agree to
                  these terms, please do not use our services.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl font-semibold">
                  2. Description of Service
                </h2>
                <p>
                  CTE provides the iPlant platform, a comprehensive solution for
                  managing electrical infrastructure, equipment tracking, and
                  related operations. Our services are designed for professional
                  use by authorized personnel and organizations.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl font-semibold">3. User Accounts</h2>
                <p>
                  To access certain features of our services, you must create an
                  account. You are responsible for:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    Maintaining the confidentiality of your account credentials
                  </li>
                  <li>All activities that occur under your account</li>
                  <li>Notifying us immediately of any unauthorized use</li>
                  <li>
                    Ensuring your account information is accurate and up-to-date
                  </li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl font-semibold">4. Acceptable Use</h2>
                <p>You agree not to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Use our services for any unlawful purpose</li>
                  <li>Attempt to gain unauthorized access to our systems</li>
                  <li>
                    Interfere with or disrupt the integrity of our services
                  </li>
                  <li>Upload malicious code or content</li>
                  <li>
                    Share your account credentials with unauthorized parties
                  </li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl font-semibold">
                  5. Intellectual Property
                </h2>
                <p>
                  All content, features, and functionality of our services,
                  including but not limited to text, graphics, logos, and
                  software, are the exclusive property of CTE and are protected
                  by intellectual property laws.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl font-semibold">6. Data and Privacy</h2>
                <p>
                  Your use of our services is also governed by our{" "}
                  <Link
                    to="/privacy"
                    className="text-primary underline underline-offset-4"
                  >
                    Privacy Policy
                  </Link>
                  , which describes how we collect, use, and protect your
                  information.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl font-semibold">
                  7. Limitation of Liability
                </h2>
                <p>
                  To the maximum extent permitted by law, CTE shall not be
                  liable for any indirect, incidental, special, consequential,
                  or punitive damages arising out of or related to your use of
                  our services.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl font-semibold">8. Modifications</h2>
                <p>
                  We reserve the right to modify these Terms of Service at any
                  time. We will notify users of any material changes by posting
                  the updated terms on our platform. Your continued use of our
                  services after such modifications constitutes acceptance of
                  the updated terms.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl font-semibold">
                  9. Contact Information
                </h2>
                <p>
                  If you have any questions about these Terms of Service, please
                  contact us at{" "}
                  <a
                    href="mailto:support@cte.com"
                    className="text-primary underline underline-offset-4"
                  >
                    support@cte.com
                  </a>
                  .
                </p>
              </section>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
